import SystemConfig from '../views/systemManage/systemConfig';

import Main from '../views/main';

const Administrators = {
  path: '/system-config',
  component: Main,
  title: '系统管理',
  icon: 'el-icon-s-custom',
  meta: { keepAlive: true },
  children: [
    {
      path: '/system-config',
      component: SystemConfig,
      name: 'systemConfig',
      title: '系统配置',
      meta: { title: '系统配置' ,keepAlive: true }
    },
    {
      path: '/system-config-ai-friend',
      component: () => import("@/views/systemManage/aiFriend"),
      name: 'systemConfigAiFriend',
      title: 'AI女友配置',
      meta: { title: 'AI女友配置' ,keepAlive: true }
    },
  ]
};
export default Administrators;
